var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { forwardRef, } from 'react';
import Label from './label';
var RadioGroup = function (_a) {
    var children = _a.children, className = _a.className, helpText = _a.helpText, label = _a.label, required = _a.required;
    return (_jsxs("fieldset", { className: classNames('mb-3', className), children: [_jsx(Label, { renderAs: "legend", className: "text-reset fs-6", helpText: helpText, required: required, children: label }), children] }));
};
var RadioInput = forwardRef(function RadioInput(_a, ref) {
    var className = _a.className, errorMessage = _a.errorMessage, id = _a.id, label = _a.label, props = __rest(_a, ["className", "errorMessage", "id", "label"]);
    return (_jsx("div", { className: classNames('form-check', className), children: _jsxs("label", { className: "form-check-label", htmlFor: id, children: [_jsx("input", __assign({ className: "form-check-input", id: id, ref: ref, type: "radio" }, props)), label, errorMessage && (_jsx("div", { className: "invalid-feedback", children: errorMessage }))] }) }));
});
RadioGroup.Input = RadioInput;
export default RadioGroup;
